import { Ref } from '../../shared/providers/ref';
import { ChatNotifier } from './chat-notifier';
import { ChatShareRepositoryProvider } from '../../shared/providers/repository-providers';
import { ChatMessageEntity, ChatRoleEnum } from '@gishub/domain';

export class SharedChatNotifier extends ChatNotifier {
  constructor(ref: Ref) {
    super(ref);
  }

  override build(): void {
    super.build();

    const segments = location.pathname.split('/').filter(Boolean);
    const id = segments[segments.length - 1];
    if (!id) return;

    const data = this.ref.read(ChatShareRepositoryProvider).instance.load(id);
    if (!data) return;

    const messages: ChatMessageEntity[] = [];
    if (data.userMsg?.role === ChatRoleEnum.User) messages.push(data.userMsg);
    if (data.aiMsg?.role === ChatRoleEnum.Ai) messages.push(data.aiMsg);
    if (messages.length > 0) {
      this.setState({ ...this.getStateValue(), messages });
    }
  }
}
